import { QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { ToastProvider } from '@/components/ui';
import { SessionProvider } from '@/features/auth/session';
import { BranchProvider } from '@/features/branch/BranchProvider';
import { createQueryClient } from '@/lib/api';
import { i18n } from '@/lib/i18n';

export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <SessionProvider>
          <BranchProvider>
            <ToastProvider>{children}</ToastProvider>
          </BranchProvider>
        </SessionProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}
